import React, { useState, useEffect } from 'react';
import '../Common/Style/Header.css';
// import CryptoJS from 'crypto-js';

// const SECRET = "mysecretpassphrase";

// AES decrypt function
// function decrypt(encryptedBase64: string): any {
//   const key = CryptoJS.SHA256(SECRET);
//   const decrypted = CryptoJS.AES.decrypt(encryptedBase64, key, {
//     mode: CryptoJS.mode.ECB,
//     padding: CryptoJS.pad.Pkcs7,
//   });
//   const plaintext = decrypted.toString(CryptoJS.enc.Utf8);
//   return JSON.parse(plaintext);
// }

const Header: React.FC = () => {
  const mobileMenuRef = React.useRef<HTMLUListElement>(null);
  const [isMenuVisible, setIsMenuVisible] = useState<boolean>(false);
  const [pageName, setPageName] = useState<string>("");
  // const [logoUrl, setLogoUrl] = useState<string>("");
  // const WebsiteLogo = sessionStorage.getItem("WebsiteLogo");
  const WebsiteLogoNew = sessionStorage.getItem("WebsiteLogo");
  // https://fmstorage.blob.core.windows.net/assets/Image/DistributorLogo/WebsiteLogoNew/DLR_KE_AU.png
  // to replace WebsiteLogoNew to WebsiteLogo

  const WebsiteLogoUpdated = WebsiteLogoNew ? WebsiteLogoNew.replace("WebsiteLogoNew", "WebsiteLogo") : null;
  const WebsiteLogo = WebsiteLogoUpdated ? WebsiteLogoUpdated : null;

  useEffect(() => {
    const currentPage = window.location.pathname;
    setPageName(currentPage);

    // // Decrypt WebsiteLogo from sessionStorage
    // const encryptedLogo = sessionStorage.getItem("WebsiteLogo");
    // if (encryptedLogo) {
    //   try {
    //     const decryptedLogo = decrypt(encryptedLogo);
    //     setLogoUrl(decryptedLogo);
    //   } catch (err) {
    //     console.error("Error decrypting WebsiteLogo:", err);
    //   }
    // }
  }, []);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        isMenuVisible &&
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target as Node)
      ) {
        setIsMenuVisible(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMenuVisible]);

  const toggleMenu = () => {
    setIsMenuVisible((prevState) => !prevState);
  };

  const isActive = (path: string) =>
    pageName === path ? { color: '#b3b3b3', cursor: 'text' } : {};

  const handleChangeUser = () => {
    
    sessionStorage.removeItem("CurrentAvatar");
    sessionStorage.removeItem("CurrentPoints");
    sessionStorage.removeItem("English_wlp_plan");
    sessionStorage.removeItem("English_wlp_status");
    sessionStorage.removeItem("Maths_wlp_status");
    sessionStorage.removeItem("Grade");
    sessionStorage.removeItem("Login");
    sessionStorage.removeItem("Maths_wlp_plan");
    sessionStorage.removeItem("Maths_Plan");
    sessionStorage.removeItem("Plan");
    sessionStorage.removeItem("TotalTrophyCount");
    sessionStorage.removeItem("WeeklyProgress");
  }

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, path: string) => {
    if (pageName === path) {
      e.preventDefault();
    }
  };

  const isMobile = window.innerWidth <= 800;
  return (
    <div id="header">
      <div className="section_div">
        <nav
          id="mobile_menu"
          className="mobile_menu"
          onClick={toggleMenu}
          style={{ backgroundPosition: isMenuVisible ? '0 100%' : '0 0' }}
        >
          <ul
            id="mobile_box"
            className="mobile_dropdown"
            ref={mobileMenuRef}
            style={{ display: isMenuVisible ? 'block' : 'none' }}
          >
            <li className="mobile_nav_item">
              <a
                href="/STUDENT/MSR/StudyRoom"
                id="hlinkStudyRoomMobile"
                style={isActive('/STUDENT/MSR/StudyRoom')}
                onClick={(e) => handleNavClick(e, '/STUDENT/MSR/StudyRoom')}
              >
                HOME
              </a>
            </li>
            
            <li className="mobile_nav_item">
              <a
                href="/STUDENT/MSR/MSRReports"
                id="hlinkReportsMobile"
                style={isActive('/STUDENT/MSR/MSRReports')}
                onClick={(e) => handleNavClick(e, '/STUDENT/MSR/MSRReports')}
              >
                REPORTS
              </a>
            </li>
            
            <li className="mobile_nav_item">
              <a
                href="/STUDENT/MSR/Profile"
                id="hlnkbtnProfileMobile"
                style={isActive('/STUDENT/MSR/Profile')}
                onClick={(e) => handleNavClick(e, '/STUDENT/MSR/Profile')}
              >
                PROFILE
              </a>
            </li>
            
            {isMobile && (
              <>
                <li className="mobile_nav_item">
                  <a
                    href="/Login/SelectUser"
                    id="linkbtnChangeUserMobile"
                    style={isActive('/Login/SelectUser')}
                    onClick={handleChangeUser}
                  >
                    CHANGE USER
                  </a>
                </li>
            
                <li className="mobile_nav_item">
                  <a
                    href="/Login/LoggedOut"
                    id="linkbtnLogOutMobile"
                    style={isActive('/Login/LoggedOut')}
                  >
                    LOG OUT
                  </a>
                </li>
              </>
            )}
          </ul>
        </nav> 

        <div id="logout_btn">
          <a href="/Login/LoggedOut" id="linkbtnLogOut" style={{padding:"2px"}}>Log Out</a>
        </div>
        <div id="divChangeUserSection">
          <a href="/Login/SelectUser" id="linkbtnChangeUser" onClick={handleChangeUser} style={{padding:"2px"}}>Change User</a>
        </div>
        <label id="lblFName" className="header_text">
          {sessionStorage.getItem("FName")}
        </label>

        <div id="scrolled_nav_sub">
          <div
            id="divLogo"
            className="scrolled_logo"
            style={{
              backgroundImage: WebsiteLogo ? `url(${WebsiteLogo})` : "none",
            }}
          >
          </div>

          <li id="sn4_sub" className="scrolled_nav_item subbed">
            <a href="/STUDENT/MSR/StudyRoom" id="hlinkStudyRoom" style={isActive('/STUDENT/MSR/StudyRoom')} onClick={(e) => handleNavClick(e, '/STUDENT/MSR/StudyRoom')}>HOME</a>
          </li>
          <li id="sn3_sub" className="scrolled_nav_item subbed">
            <a href="/STUDENT/MSR/MSRReports" id="hlinkReports" style={isActive('/STUDENT/MSR/MSRReports')} onClick={(e) => handleNavClick(e, '/STUDENT/MSR/MSRReports')}>REPORTS</a>
          </li>
          <li id="sn2_sub" className="scrolled_nav_item subbed">
            <a href="/STUDENT/MSR/Profile" id="hlnkbtnProfile" style={isActive('/STUDENT/MSR/Profile')} onClick={(e) => handleNavClick(e, '/STUDENT/MSR/Profile')}>PROFILE</a>
          </li>
        </div>
      </div>
    </div>
  );
};

export default Header;